var map = {
	"./symbol_0.png": 31747,
	"./symbol_1.png": 26522,
	"./symbol_10.png": 64640,
	"./symbol_11.png": 35817,
	"./symbol_2.png": 34833,
	"./symbol_3.png": 94888,
	"./symbol_4.png": 86407,
	"./symbol_5.png": 98718,
	"./symbol_6.png": 84469,
	"./symbol_7.png": 1580,
	"./symbol_8.png": 97819,
	"./symbol_9.png": 32466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42854;